import { CSSProperties } from 'react'

export const ESIGNATURE_PDF_SECTION_STYLES: CSSProperties = {
  paddingLeft: '55px',
  paddingRight: '55px',
}

export const SIGNATURE_BOX_ID = 'js-signature-box'
